import {
  COMPOUNDING_PERIOD_ROW_NUMBER,
  COMPOUNDING_ROW_NUMBER,
  DIVIDEND_RATE_ROW_NUMBER,
  ISSUE_PRICE_ROW_NUMBER,
} from 'common/constants/cap-table';

// Accrued Dividends expression shared by the Liquidation Preference Ledger and
// Multiple Investment Dates ledgers. The @N references resolve against the parent
// security's column in the MAIN cap-table grid, while date#/shares# resolve within
// the ledger's own row.
// In case we update/change this formula, we need to update the formula
// on the backend as well (app.cap_table.models.Security.calculate_accrued_dividends)
const buildAccruedDividendsExpr = (measurementDate: string): string =>
  `=IF(@${COMPOUNDING_ROW_NUMBER}==Y,(@${ISSUE_PRICE_ROW_NUMBER} * (1+@${DIVIDEND_RATE_ROW_NUMBER}/@${COMPOUNDING_PERIOD_ROW_NUMBER}) ^ (YEARFRAC(date#, "${measurementDate}", 3) * @${COMPOUNDING_PERIOD_ROW_NUMBER}) - @${ISSUE_PRICE_ROW_NUMBER}) * shares#, @${DIVIDEND_RATE_ROW_NUMBER} * @${ISSUE_PRICE_ROW_NUMBER} * shares# *YEARFRAC(date#, "${measurementDate}", 3))`;

export default buildAccruedDividendsExpr;
